import React, { FC, useMemo, useEffect, useState } from 'react'
import { Box, VStack, Image } from '@chakra-ui/react'
import { ProviderAutoComplete } from './providerAutocomplete'
import { CountryAutoComplete } from './countryAutocomplete'
import { cardImageMap, CountryInfo, ProviderInfo, ProviderType, ScenarioType } from '../../state/interfaces'
import { useSelector } from 'react-redux'
import { selectScenario } from '../../state'
import { getProviderTypeFromScenario } from '../../scenarios/utils'
import countriesJson from '../../countries.json'
const { countriesData } = countriesJson

export interface InputAutoCompleteProps {
  placeholder?: string
  onChange?: (values: string[]) => void
  name: string
  grandImage?: string
}

export const InputAutoComplete: FC<InputAutoCompleteProps> = ({ placeholder, onChange, name, grandImage }) => {
  const [providers, setProviders] = useState<ProviderInfo[] | null>([])
  const [countries, setCountries] = useState<CountryInfo[] | null>([])
  const scenario = useSelector(selectScenario)
  const image = useMemo(() => (grandImage ? cardImageMap[grandImage] : ''), [grandImage])
  // const { t } = useTranslation()

  if (scenario!.type !== ScenarioType.CANADA_VISITOR && scenario!.type !== ScenarioType.COUNTRY) {
    useEffect(() => {
      let providersEndpoint = `${process.env.REACT_APP_MOBILE_PROVIDERS_API_URL}`
      const providerType: ProviderType = getProviderTypeFromScenario(scenario)

      if (providerType === ProviderType.INTERNET) {
        providersEndpoint = `${process.env.REACT_APP_INTERNET_PROVIDERS_API_URL}`
      }

      fetch(providersEndpoint)
        .then((result) => result.json())
        .then((providers) => setProviders(providers))
    }, [])
  } else {
    useEffect(() => {
      setCountries(countriesData)
    }, [])
  }

  // const handleOnClick = () => {
  //   onChange && onChange([''])
  // }

  return (
    <VStack spacing={3} marginY={8}>
      {scenario!.type !== ScenarioType.CANADA_VISITOR && scenario!.type !== ScenarioType.COUNTRY ? (
        <Box>
          <ProviderAutoComplete data={providers} placeholder={placeholder} onChange={onChange} name={name} />
        </Box>
      ) : (
        <VStack>
          <Box marginBottom={8}>
            <CountryAutoComplete data={countries} placeholder={placeholder} onChange={onChange} name={name} />
          </Box>
          {/* {scenario!.type !== ScenarioType.COUNTRY && (
            <Box>
              <Button
                role={'button'}
                layerStyle={theme.LayerStyles.SMALL_PILL}
                onClick={() => {
                  handleOnClick()
                }}
              >
                <Box color="white" fontSize={16}>
                  {t('common_skip')}
                </Box>
              </Button>
            </Box>
          )} */}
          {image && <Image src={image} alt="image" width={['0', '250px']} height={['0', '250px']} />}
        </VStack>
      )}
    </VStack>
  )
}
